import { createLazyReactDirective } from '../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./TasksOverview')).TasksOverview,
  'tasksOverview',
  {
    routeParams: '=',
  },
);
